/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { NatureOfComplaintDomestic, NatureOfComplaintInternational, Region } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../shared/types/step-config.type';
import { AffectedItemsDamageDomesticStepConfig } from '../components/steps/affected-items-damage-domestic/affected-items-damage-domestic.config';
import { AffectedItemsStepConfig } from '../components/steps/affected-items/affected-items.config';
import { ReferenceNumberDomesticStepConfig } from '../components/steps/reference-number-domestic/reference-number-domestic.config';
import { RegionStepConfig } from '../components/steps/region/region.config';
import { CodCreateForm } from '../models/cod-create.model';
import { OrderEntryDomesticStepConfig } from '../components/steps/order-entry-domestic/order-entry-domestic.config';
import { ItemOrQuantityDomesticStepConfig } from '../components/steps/item-or-quantity-domestic/item-or-quantity-domestic.config';
import { ProductDatingDomesticStepConfig } from '../components/steps/product-dating-domestic/product-dating-domestic.config';
import { ProductDamageDomesticStepConfig } from '../components/steps/product-damage-domestic/product-damage-domestic.config';
import { ProductTemperatureDomesticStepConfig } from '../components/steps/product-temperature-domestic/product-temperature-domestic.config';
import { DeliveryErrorDomesticStepConfig } from '../components/steps/delivery-error-domestic/delivery-error-domestic.config';
import { InvoiceErrorDomesticStepConfig } from '../components/steps/invoice-error-domestic/invoice-error-domestic.config';
import { BillingAdjustmentDomesticStepConfig } from '../components/steps/billing-adjustment-domestic/billing-adjustment-domestic.config';
import { EskerDiscrepancyDomesticStepConfig } from '../components/steps/esker-discrepancy/esker-discrepancy-domestic.config';
import { LargeInstrumentWarehouseDiscrepancyStepConfig } from '../components/steps/large-instrument-warehouse-discrepancy/large-instrument-warehouse-discrepancy.config';
import { ReferenceNumberInternationalStepConfig } from '../components/steps/reference-number-international/reference-number-international.config';
import { AffectedItemsDamageInternationalStepConfig } from '../components/steps/affected-items-damage-international/affected-items-damage-international.config';
import { AffectedItemsInvoiceErrorInternationalStepConfig } from '../components/steps/affected-items-invoice-error-international/affected-items-invoice-error-international.config';
import { AffectedItemsQualityStepConfig } from '../components/steps/affected-items-quality/affected-items-quality.config';
import { OrderEntryInternationalStepConfig } from '../components/steps/order-entry-international/order-entry-international.config';
import { ItemOrQuantityInternationalStepConfig } from '../components/steps/item-or-quantity-international/item-or-quantity-international.config';
import { ProductDatingInternationalStepConfig } from '../components/steps/product-dating-international/product-dating-international.config';
import { ProductDamageInternationalStepConfig } from '../components/steps/product-damage-international/product-damage-international.config';
import { ProductTemperatureInternationalStepConfig } from '../components/steps/product-temperature-international/product-temperature-international.config';
import { DeliveryErrorInternationalStepConfig } from '../components/steps/delivery-error-international/delivery-error-international.config';
import { DocumentationInternationalStepConfig } from '../components/steps/documentation-international/documentation-international.config';
import { InvoiceErrorInternationalStepConfig } from '../components/steps/invoice-error-international/invoice-error-international.config';
import { QualityInternationalStepConfig } from '../components/steps/quality-international/quality-international.config';
import { AffectedItemsQuantityDomesticStepConfig } from '../components/steps/affected-items-quantity-domestic/affected-items-quantity-domestic.config';
import { AffectedItemsQuantityInternationalStepConfig } from '../components/steps/affected-items-quantity-international/affected-items-quantity-international.config';
import { AffectedItemsOrderEntryDomesticStepConfig } from '../components/steps/affected-items-order-entry-domestic/affected-items-order-entry-domestic.config';

export class CodStepOperations {
    public static evaluateSteps(
        form: CodCreateForm,
        referenceNumberDomesticStatus: string,
        referenceNumberInternationalStatus: string,
        version = 'fy26'
    ): StepConfig[] {
        const steps = [RegionStepConfig];

        const domestic = form?.region.region === Region.NAM;
        const international = !domestic && form?.region.region !== null;

        // Step 1: Reference Number
        if (domestic) {
            steps.push(ReferenceNumberDomesticStepConfig);

            const natureOfComplaint = form?.referenceNumberDomestic.natureOfComplaint;
            const valid = referenceNumberDomesticStatus === 'VALID';

            if (natureOfComplaint && valid) {
                switch (natureOfComplaint) {
                    case NatureOfComplaintDomestic.PRODUCT_DAMAGE:
                        steps.push(AffectedItemsDamageDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.ITEM_OR_QUANTITY:
                        steps.push(AffectedItemsQuantityDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.ORDER_ENTRY:
                        if (version === 'fy26') {
                            steps.push(AffectedItemsOrderEntryDomesticStepConfig);
                        } else {
                            steps.push(AffectedItemsStepConfig);
                        }
                        break;
                    default:
                        steps.push(AffectedItemsStepConfig);
                        break;
                }
            }

            const affectedItems = form!.affectedItems.confirmed;

            if (affectedItems && valid) {
                switch (natureOfComplaint) {
                    case NatureOfComplaintDomestic.ORDER_ENTRY:
                        steps.push(OrderEntryDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.ITEM_OR_QUANTITY:
                        steps.push(ItemOrQuantityDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.PRODUCT_DATING:
                        steps.push(ProductDatingDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.PRODUCT_DAMAGE:
                        steps.push(ProductDamageDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.PRODUCT_TEMPERATURE:
                        steps.push(ProductTemperatureDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.DELIVERY:
                        steps.push(DeliveryErrorDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.INVOICE_ERROR:
                        steps.push(InvoiceErrorDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.BILLING_ADJUSTMENT:
                        steps.push(BillingAdjustmentDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.ESKER:
                        steps.push(EskerDiscrepancyDomesticStepConfig);
                        break;
                    case NatureOfComplaintDomestic.LARGE_INSTRUMENT_WAREHOUSE:
                        steps.push(LargeInstrumentWarehouseDiscrepancyStepConfig);
                        break;
                    default:
                        break;
                }
            }
        }

        if (international) {
            steps.push(ReferenceNumberInternationalStepConfig);

            const natureOfComplaint = form?.referenceNumberInternational.natureOfComplaint;
            const valid = referenceNumberInternationalStatus === 'VALID';

            if (natureOfComplaint && valid) {
                switch (natureOfComplaint) {
                    case NatureOfComplaintInternational.PRODUCT_DAMAGE:
                        steps.push(AffectedItemsDamageInternationalStepConfig);
                        break;
                    case NatureOfComplaintInternational.INVOICE_ERROR:
                        steps.push(AffectedItemsInvoiceErrorInternationalStepConfig);
                        break;
                    case NatureOfComplaintInternational.QUALITY:
                        steps.push(AffectedItemsQualityStepConfig);
                        break;
                    case NatureOfComplaintInternational.ITEM_OR_QUANTITY:
                        steps.push(AffectedItemsQuantityInternationalStepConfig);
                        break;
                    default:
                        steps.push(AffectedItemsStepConfig);
                        break;
                }
            }

            const affectedItems = form!.affectedItems.confirmed;

            if (affectedItems && valid) {
                switch (natureOfComplaint) {
                    case NatureOfComplaintInternational.ORDER_ENTRY:
                        steps.push(OrderEntryInternationalStepConfig);
                        break;
                    case NatureOfComplaintInternational.ITEM_OR_QUANTITY:
                        steps.push(ItemOrQuantityInternationalStepConfig);
                        break;
                    case NatureOfComplaintInternational.PRODUCT_DATING:
                        steps.push(ProductDatingInternationalStepConfig);
                        break;
                    case NatureOfComplaintInternational.PRODUCT_DAMAGE:
                        steps.push(ProductDamageInternationalStepConfig);
                        break;
                    case NatureOfComplaintInternational.PRODUCT_TEMPERATURE:
                        steps.push(ProductTemperatureInternationalStepConfig);
                        break;
                    case NatureOfComplaintInternational.DELIVERY:
                        steps.push(DeliveryErrorInternationalStepConfig);
                        break;
                    case NatureOfComplaintInternational.DOCUMENTATION:
                        steps.push(DocumentationInternationalStepConfig);
                        break;
                    case NatureOfComplaintInternational.INVOICE_ERROR:
                        steps.push(InvoiceErrorInternationalStepConfig);
                        break;
                    case NatureOfComplaintInternational.QUALITY:
                        steps.push(QualityInternationalStepConfig);
                        break;
                    default:
                        break;
                }
            }
        }

        return steps;
    }
}
